import { streamConfig } from '@/feature/dataStream/streamConfig';
import queryClient from '../query/queryClient';
import { MeasurementSystem } from './api.types';
import { useUpdateLocalizationSetting } from './mutations';
import { useLocalizationSettingsQuery } from './queries';

export const useMeasurementSystem = () => {
  const { data } = useLocalizationSettingsQuery();
  const { mutateAsync: updateApiMeasurementSystem } =
    useUpdateLocalizationSetting('measurementsystem');

  const updateMeasurementSystem = (value: MeasurementSystem) => {
    updateApiMeasurementSystem(value).then(() => {
      queryClient.invalidateQueries();
      streamConfig.setMeasurementSystem(value);
    });
  };

  return {
    measurementSystem: data?.measurementSystem ?? 'metric',
    updateMeasurementSystem,
  };
};
